import React from 'react';
import { CheckHeavy } from '@sighten/beacon/icons';
import { ArrowUpRightFromSquare } from 'shared/components/icons/ArrowUpRightFromSquare';
import {
  StepWrapper,
  StepIndicatorColumn,
  StepConnectorTop,
  StepIconWrapper,
  StepCircle,
  StepConnector,
  StepRightColumn,
  StepTitleGroup,
  StepTitle,
  StepTitleLink,
  StepStatusText,
  StepBulletList,
  type TransferProgressStepStatus,
} from './TransferProgressStep.styles';

export type { TransferProgressStepStatus };

interface Props {
  status: TransferProgressStepStatus;
  title: string;
  titleHref?: string;
  statusText?: string;
  bullets?: string[];
  hasPrev: boolean;
  nextStatus: TransferProgressStepStatus | null;
}

export function TransferProgressStep({
  status,
  title,
  titleHref,
  statusText,
  bullets = [],
  hasPrev,
  nextStatus,
}: Props) {
  return (
    <StepWrapper>
      <StepIndicatorColumn>
        <StepConnectorTop $hasPrev={hasPrev} $status={status} />
        <StepIconWrapper>
          <StepCircle $status={status}>
            {status === 'complete' && <CheckHeavy size="sm" />}
          </StepCircle>
        </StepIconWrapper>
        <StepConnector $nextStatus={nextStatus} />
      </StepIndicatorColumn>
      <StepRightColumn>
        <StepTitleGroup>
          {titleHref ? (
            <StepTitleLink href={titleHref} target="_blank" rel="noopener noreferrer">
              {title}
              <ArrowUpRightFromSquare />
            </StepTitleLink>
          ) : (
            <StepTitle $status={status}>{title}</StepTitle>
          )}
          {statusText && <StepStatusText $status={status}>{statusText}</StepStatusText>}
        </StepTitleGroup>
        {bullets.length > 0 && (
          <StepBulletList $status={status}>
            {bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </StepBulletList>
        )}
      </StepRightColumn>
    </StepWrapper>
  );
}

export default TransferProgressStep;
